module.exports = __webpack_public_path__ + "static/media/05_avatar_female.fd81e7a4.png";